import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import {
  ACTION_REGISTRATION_LOADED,
  ACTION_REGISTRATION_ERROR,
  ACTION_REGISTRATION_LOADING,
  PATH_REGISTRATION
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = (data) => {
  return Observable.of({
    type: ACTION_REGISTRATION_ERROR,
    payload: data
  })
}

const epic = action$ =>
  action$.ofType(ACTION_REGISTRATION_LOADING)
    .mergeMap(action => {

      return ajax({
        method: 'POST',
        url: `${api_server_host}${PATH_REGISTRATION}`,
        headers:{
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(action.payload),
        responseType: 'json'
      }).map(data=> {

        return {
          type: ACTION_REGISTRATION_LOADED,
          payload: data
        }
      }).catch(errorHandler)
    })

export default epic



// WEBPACK FOOTER //
// ./src/epics/RegistrationEpic.js